// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__13ZK3","log":"ModalInventoryLogs_log__1q2qL","date":"ModalInventoryLogs_date__30dlE","userName":"ModalInventoryLogs_userName__2TIqj"};